import { IActiveUsersDTO, IDelayedPanicRequestDTO, IInstallationInfoDTO, IPanicRequestDTO, ITrackingUsersDTO, IUserLocationRequestDTO } from "api/swagger/ApiClient";

export interface ActiveUsersData {
  headerActiveUsers: IActiveUsersDTO;
  activeUsers: IActiveUsersDTO[]
}

export interface TrackingUsersData {
  headerTrackingUsers: ITrackingUsersDTO;
  trackingUsers: ITrackingUsersDTO[];
}

export interface InstalledVersionsData {
  total: number;
  latest: number;
  installedVersions: IInstallationInfoDTO[];
}

export interface PanicRequestsData {
  active: number;
  isTest: boolean;
  panicRequests: IPanicRequestDTO[];
}

export interface DelayedPanicRequestModel extends IDelayedPanicRequestDTO {
  panicRequest: IPanicRequestDTO;
  activeIn: string;
  showPanicRequest(panicRequest: IPanicRequestDTO): Promise<void>;
}

export interface UserLocationNotFoundToastModel {
  userName: string;
  userUniqueId: string
  requestLocation(userUniqueId: string): null;
}

export interface UserLocationRequestModel extends IUserLocationRequestDTO {
  hasLocation: boolean;
  showLocation(userUniqueId: string, userName: string): Promise<void>;
}

export interface MobileAppEvent {
  type: EventType;
  date: string;
  data: any;
}

export enum EventType {
  UserLocationRequest = 1
}

